import React from 'react';
import { Container } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const randomColor = require('randomcolor');

let color = randomColor({
  count: 10000,
  hue: 'random',
  luminosity: 'light',
});

const CategorieGraphic = ({ categoriesArr }) => {
  const { t } = useTranslation();
  const categoriesValuesArr = [];
  const categoriesLabelsArr = [];
  let state;

  categoriesArr.map((categorie) => {
    categoriesValuesArr.push(categorie.value);
    categoriesLabelsArr.push(categorie.categorieName);
  });

  state = {
    dataDoughnut: {
      labels: categoriesLabelsArr,
      datasets: [
        {
          label: '',
          data: categoriesValuesArr,
          backgroundColor: color,
        },
      ],
    },

    options: {
      tooltips: {
        enabled: true,
        callbacks: {
          beforeLabel: function (tooltipItem, data) {
            return data.labels[tooltipItem.index];
          },
          label: function (tooltipItem, data) {
            let value = data.datasets[0].data[tooltipItem.index];
            if (parseInt(value) > 0) {
              return value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
            }
          },
        },
      },
      legend: {
        display: false,
      },
      maintainAspectRatio: false,
      title: {
        display: true,
        text: t('label:activity'),
      },
      responsive: true,
    },
  };

  return (
    <>
      {categoriesArr.length !== 0 ? (
        <Doughnut
          data={state.dataDoughnut}
          options={state.options}
          width={100}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default CategorieGraphic;
